import { Injectable } from '@angular/core';
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { environment } from 'src/environments/environment';
// import { PopUp } from '../pop-up-service/pop-up-service.service';
import { TranslateService } from '@ngx-translate/core';
// import { RedirectService } from '../dataservice/redirect-service/redirect.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UserType } from 'src/app/enums/user';
import { promisify } from 'util';
// import * as jsonwebtoken from 'jsonwebtoken';
// const jwkToPem = require('jwk-to-pem');

// const COGNITO_ISSUER = `https://cognito-idp.${environment.aws.cognito.user_pool.region}.amazonaws.com/${environment.aws.cognito.user_pool.user_pool_id}`;

export interface ClaimVerifyRequest {
  readonly token?: string;
}

export interface ClaimVerifyResult {
  readonly userName: string;
  readonly clientId: string;
  readonly isValid: boolean;
  readonly error?: any;
}

interface TokenHeader {
  kid: string;
  alg: string;
}
interface PublicKey {
  alg: string;
  e: string;
  kid: string;
  kty: string;
  n: string;
  use: string;
}
interface PublicKeyMeta {
  instance: PublicKey;
  pem: string;
}

interface PublicKeys {
  keys: PublicKey[];
}

interface MapOfKidToPublicKey {
  [key: string]: PublicKeyMeta;
}

interface Claim {
  token_use: string;
  auth_time: number;
  iss: string;
  exp: number;
  username: string;
  client_id: string;
}

export interface TokenValidityResults {
  token: string;
  isExpired: boolean;
}

export class TokenExpiredException extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, TokenExpiredException.prototype);
  }
}


@Injectable({
  providedIn: 'root'
})
export class CognitoService {

  constructor(
    private translate: TranslateService,
    private router: Router,
    private http: HttpClient,
  ) { }

  authenticate(email: string, password: string) {
    return new Promise((resolved, reject) => {
      const username = email;
      // clear cache & sign out previouse logged in user before signing in
      // (so that auth returns most updated user info)
      // this.cache.logoutClear();
      Auth.signOut().then(() => {
        Auth.signIn({
          username,
          password
        }).then(user => {
          console.log('signedInUser:', user);
          resolved(user);
        }).catch(error => {
          reject(error);
        });
      });
    });
  }

  signOut() {
    return new Promise((resolved, reject) => {
      Auth.signOut()
        .then(result => {
          console.log('Signed Out User');
          resolved(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }


  checkCurrentUser() {
    return new Promise((resolve, reject) => {
      Auth.currentAuthenticatedUser()
        .then(user => resolve(user))
        .catch(err => reject(err));
    });
  }

  getAccessToken(): Promise<string> {
    return new Promise(async (resolve, reject) => {
      const authRes = await Auth.currentSession();
      // console.log('access token :: ', authRes.getAccessToken());
      resolve(authRes.getAccessToken().getJwtToken());
    });
  }


  // forget password
  // trigger to send OTP
  forgotPassword(username: string) {
    return new Promise((resolved, reject) => {
      Auth.forgotPassword(username)
        .then(result => {
          console.log(result);
          resolved(result);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }

  // update password with the OTP provided
  forgotPasswordSubmit(username: string, code, newPassword) {
    return new Promise((resolved, reject) => {
      Auth.forgotPasswordSubmit(username, code, newPassword)
        .then(result => {
          resolved(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  // change password
  changePassword(oldPassword: string, newPassword: string) {
    return new Promise((resolved, reject) => {
      Auth.currentAuthenticatedUser()
        .then(user => {
          return Auth.changePassword(user, oldPassword, newPassword);
        })
        .then(result => {
          resolved(result);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }

  updateAwsCognitoPool(userTypeEnum = UserType.AGENT): void {
    console.log('updating user pool for user type: ', userTypeEnum);
    const userType = userTypeEnum === UserType.AGENT ? 'agent' : 'customer';
    Amplify.configure({
      Auth: {
        identityPoolId: environment.aws[userType].cognito.identity_pool.identity_pool_id,
        identityPoolRegion: environment.aws[userType].cognito.identity_pool.region,
        region: environment.aws[userType].cognito.user_pool.region,
        userPoolId: environment.aws[userType].cognito.user_pool.user_pool_id,
        userPoolWebClientId: environment.aws[userType].cognito.user_pool.app_client_id
      },
      // oauth: {
      //   domain: environment.aws.cognito.oauth.domain,
      //   scope: environment.aws.cognito.oauth.scope,
      //   redirectSignIn: environment.aws.cognito.oauth.redirectSignIn,
      //   redirectSignOut: environment.aws.cognito.oauth.redirectSignOut,
      //   responseType: environment.aws.cognito.oauth.responseType
      // }
    });
  }

}
